module.exports = __webpack_public_path__ + "media/fun/fun-4-4870d560.jpg";